import React from "react";

const ServicePromo = () => {
  return (
    <section className="services-icon ptb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="section-heading text-center">
              <h2>Services We Provide</h2>
              <p>
                Credibly grow premier ideas rather than bricks-and-clicks
                strategic theme areas distributed for stand-alone web-readiness.
              </p>
            </div>
            ,
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center mt-3 border-bottom border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/coding.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="service-info-wrap">
                <h3 className="h5">Web Development</h3>
                <p>
                  Holisticly morph distinctive methodologies and vertical
                  e-tailers. Rapidiously grow customized data.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center mt-3 border-bottom border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/app-development.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="service-info-wrap">
                <h3 className="h5">App Development</h3>
                <p>
                  Holisticly morph distinctive methodologies and vertical
                  e-tailers. Rapidiously grow customized data.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center mt-3 border-bottom">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/shield.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="service-info-wrap">
                <h3 className="h5">Data Sceurity</h3>
                <p>
                  Holisticly morph distinctive methodologies and vertical
                  e-tailers. Rapidiously grow customized data.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/curve.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="feature-info-wrap">
                <h3 className="h5">UI/UX Design</h3>
                <p>
                  Holisticly morph distinctive methodologies and vertical
                  e-tailers. Rapidiously grow customized data.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center border-end">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/graphic-design.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="feature-info-wrap">
                <h3 className="h5">Graphics Design</h3>
                <p>
                  Holisticly morph distinctive methodologies and vertical
                  e-tailers. Rapidiously grow customized data.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-6 p-0">
            <div className="single-service p-lg-5 p-4 text-center">
              <div className="service-icon icon-center">
                <img
                  src="assets/img/service/promotion.png"
                  alt="service icon"
                  width="65"
                  height="65"
                />
              </div>
              <div className="feature-info-wrap">
                <h3 className="h5">Digital Marketing</h3>
                <p>
                  Holisticly morph distinctive methodologies and vertical
                  e-tailers. Rapidiously grow customized data.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicePromo;
